"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLanguage = void 0;
class UpdateLanguage {
    constructor(profileService) {
        this.profileService = profileService;
    }
    execute(request) {
        return this.profileService.updateLanguage(request);
    }
}
exports.UpdateLanguage = UpdateLanguage;
